import useAuthContext from "../../hooks/useAuthContext"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ListNotificationService, NotificationService } from "./NotificationService";
import { useMemo } from "react";

const queryNotification = () => {
  const { user, isAuthenticated } = useAuthContext()
  const queryClient = useQueryClient();

  const updateCacheById = (id) => {
    const oldData = queryClient.getQueryData(['notification-list']);
    const newData = oldData?.data?.data.map((item) => {
      if (item.id === id) {
        return { ...item, read: 1 };
      }
      return item;
    });
    queryClient.setQueryData(['notification-list'], {
      ...oldData,
      data: {
        ...oldData?.data,
        data: newData,
      }
    });
  }

  const addCache = (data) => {
    if (!data || !Array.isArray(data) || !data.length) return;
    const oldData = queryClient.getQueryData(['notification-list']);
    const dataData = oldData?.data?.data || [];
    const newData = [...data, ...dataData];
    queryClient.setQueryData(['notification-list'], {
      ...oldData,
      data: {
        ...oldData?.data,
        data: newData,
      }
    });
  }
  
  const notification = () => {
    const { data, isLoading, isError, error, ...rest } = useMutation((opt) => NotificationService({
      notification: opt,
      token: user.access_token,
    }), {
      onSuccess: (_, opt) => {
        // get old data and update
        updateCacheById(opt);
      }
    });

    const dataResult = data?.data.data || [];

    return { data: dataResult, isLoading, isError, error, ...rest };
  }

  const listNotification = (read = 0) => {
    const { data, isLoading, isError, error, ...rest } = useQuery(['notification-list'], () => ListNotificationService({
      body: {        
        user_id: user?.id || 0, // no authenticated, no data
        read,
      },
      token: user?.access_token || '',
    }), {
      staleTime: 1000 * 60 * 5, // 5 minutes
      enabled: isAuthenticated,
    });

    const dataResult = useMemo(() => data?.data.data || [], [data]);

    return { data: dataResult, isLoading, isError, error, ...rest };
  }

  return { notification, listNotification, addCache };
}

export default queryNotification;
